import { gql } from "@apollo/client";
import { alpha } from "@mui/material";
import FetchMoreButton from "atoms/FetchMoreButton";
import Grid from "atoms/Grid";
import { PageContentStack } from "atoms/Stack";
import Stack from "atoms/Stack";
import { MAX_CONTENT_WIDTH } from "helpers/breakpoints";
import { COLOR_BLACK, COLOR_WHITE_LIGHTER } from "helpers/colors";
import { SPACING } from "helpers/spacings";
import useData from "helpers/useData";
import useEnforceAuth from "helpers/useEnforceAuth";
import useRouteState from "helpers/useRouteState";
import React from "react";
import { TeamPageTitle } from "shared/PageTitle";

import GameEntry, { GameEntryFragment } from "./games/GameEntry";
import TeamPagesHeader from "./team/TeamPagesHeader";
import TeamSeasonSelectSubnav from "./team/TeamSeasonSelectSubnav";

export default function TeamGamesPage({ teamId }) {
  useEnforceAuth({ enforceAuthenticated: true });

  const [seasonId, seasonIdSet] = useRouteState("seasonId");
  const [data, dataMeta] = useData(
    gql`
      query TeamGamesPage($teamId: ID!, $seasonId: ID, $offset: Int) {
        team(id: $teamId) {
          id
        }
        currentUser {
          id
          gamesCount(teamId: $teamId, seasonId: $seasonId)
          games(teamId: $teamId, seasonId: $seasonId, offset: $offset, limit: 10) {
            id
            ...GameEntryFragment
          }
        }
      }
      ${GameEntryFragment}
    `,
    { teamId, seasonId },
  );

  return (
    <>
      <TeamPageTitle title="Games" />
      <TeamPagesHeader teamId={teamId} tab="games" />
      <div
        style={{
          backgroundColor: COLOR_WHITE_LIGHTER,
          borderBottom: `1px solid ${alpha(COLOR_BLACK, 0.1)}`,
        }}
      >
        <TeamSeasonSelectSubnav teamId={teamId} seasonId={seasonId} seasonIdSet={seasonIdSet} allowAllSeasons />
      </div>
      <PageContentStack>
        <Stack
          gap={SPACING}
          style={{ margin: "0 auto", maxWidth: MAX_CONTENT_WIDTH, width: `calc(100vw - ${SPACING} * 2)` }}
        >
          {data?.currentUser?.games?.length > 0 && (
            <Grid>
              {data.currentUser.games.map((game) => (
                <GameEntry key={game.id} game={game} />
              ))}
            </Grid>
          )}
          <FetchMoreButton
            dataMeta={dataMeta}
            rows={data?.currentUser?.games}
            rowsCount={data?.currentUser?.gamesCount}
          />
        </Stack>
      </PageContentStack>
    </>
  );
}
